import { z } from 'zod';
import { IntelligenceTierEnum } from './novel.schema';

/**
 * Supported AI providers.
 */
export const AiProviderEnum = z.enum(['cloudflare', 'googleai', 'groq', 'openai', 'openrouter']);
export type AiProvider = z.infer<typeof AiProviderEnum>;

/**
 * Resolved model configuration.
 */
export const ResolvedModelSchema = z.object({
  provider: AiProviderEnum,
  model: z.string(),
  tokenWeight: z.number().default(1),
});
export type ResolvedModel = z.infer<typeof ResolvedModelSchema>;

/**
 * Action keys for AI operations.
 */
export const AiActionEnum = z.enum([
  'text:writing',
  'text:style',
  'text:continuity',
  'text:lore',
  'text:fixer',
  'text:extraction',
  'text:analysis',
  'text:storyboard',
  'text:character',
  'text:character-fields',
  'text:chapter-insights',
  'text:embedding',
  'image:fast',
  'image:consistent',
  'image:inpaint',
  'image:style',
]);
export type AiAction = z.infer<typeof AiActionEnum>;

/**
 * Matrix configuration for AI governance.
 */
export const AiGovernanceSchema = z.object({
  matrix: z.record(
    AiActionEnum,
    z.record(IntelligenceTierEnum, ResolvedModelSchema)
  ),
  updatedAt: z.string().datetime(),
});
export type AiGovernance = z.infer<typeof AiGovernanceSchema>;
